export const osnMoveToTopIcon = {
  data: `<svg viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 4.5L12 1L15.5 4.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="1" y1="8" x2="23" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="1" y1="13" x2="23" y2="13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
  name: 'move-to-top',
};
